import {
  faChartArea,
  faHandshakeAngle,
  faScaleUnbalanced,
} from "@fortawesome/pro-duotone-svg-icons"

import WizardCard from "../../components/WizardCard"
import HorizontalIconCard from "../../components/HorizontalIconCard"
import useMediaQuery from "../../hooks/useMediaQuery"

const GovtIntroductionWhoIsNCXCard = () => {
  const isMaxWidthSm = useMediaQuery("(max-width: 664px)")

  return (
    <WizardCard paddingSize={isMaxWidthSm ? "sm" : "lg-y"}>
      <div className="flex flex-col gap-6">
        <h2 className="text-2xl font-display font-medium leading-[124%] tracking-[0.48px]">
          Who is NCX?
        </h2>

        <p className="text-charcoal-500 text-sm leading-[140%] tracking-[0.28px]">
          At NCX, we specialize in connecting landowners to tailored programs,
          maximizing your land's potential. Whether it's carbon sequestration,
          wildlife habitat, or water resources—your unique land characteristics
          matter.
        </p>

        <HorizontalIconCard
          icon={faChartArea}
          heading="Who are we"
          text="NCX founders Zack Parisa and Max Nova started the company in 2010. Originally, the focus was on commercializing a satellite-based forest measurement technology that Zack had invented at the Yale School of Forestry. It has now grown to tap into problem solving for landowners."
        />

        <HorizontalIconCard
          icon={faScaleUnbalanced}
          heading="Do you know the value of your land?"
          text="The timber, carbon, water, and wildlife on your land are valuable natural capital assets. Natural capital markets represent exciting potential income streams for landowners. NCX supports landowners with the knowledge of its worth and steps to increase its value."
        />

        <HorizontalIconCard
          icon={faHandshakeAngle}
          heading="Founded on trust and expertise"
          text="NCX's technology has been trusted and  used by large institutional landowners, corporate carbon credit purchasers, project developers, certification bodies, and forestry professionals to quantify and transact on natural capital."
        />
      </div>
    </WizardCard>
  )
}

export default GovtIntroductionWhoIsNCXCard
